import React from "react";
import Effects from "./Effects";
import Img from "./Img";

const Card = ({ bg, hoverImg, badge, category, href, className = "", children }) => {
  const childArray = React.Children.toArray(children);
  const body = childArray[0] ?? null;
  const icons = childArray[1] ?? null;
  const iconItems = icons ? React.Children.toArray(icons.props.children) : [];

  const Wrapper = href ? "a" : "div";

  return (
    <div
      className={`group relative cursor-pointer flex h-full flex-col overflow-hidden rounded-xl border border-gray-200 bg-white transition-all duration-300 hover:-translate-y-0.5 hover:border-gray-300 ${className}`}
    >
      {/* Image container */}
      <div className="relative w-full overflow-hidden aspect-[3/4] bg-gray-50">
        <Wrapper href={href} className="relative block w-full h-full">
          <Img
            src={bg}
            alt=""
            className="w-full h-full object-cover transition-[opacity,transform] duration-700 ease-out group-hover:scale-[1.04] group-hover:opacity-0"
          />

          {hoverImg && (
            <Img
              src={hoverImg}
              alt=""
              className="absolute inset-0 w-full h-full object-cover opacity-0 scale-100 transition-[opacity,transform] duration-700 ease-out group-hover:opacity-100 group-hover:scale-[1.07]"
            />
          )}

          <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-black/20 via-transparent to-white/10 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        </Wrapper>

        {badge && (
          <div className="absolute top-3 left-3 z-10 rounded-full bg-gray-950 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-white pointer-events-none">
            {badge}
          </div>
        )}

        {category && (
          <div className="absolute top-3 right-3 z-10 max-w-[55%] truncate rounded-full border border-gray-200 bg-white/90 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-wide text-gray-800 backdrop-blur pointer-events-none">
            {category}
          </div>
        )}

        {iconItems.length > 0 && (
          <div className="absolute bottom-4 left-0 right-0 z-20 flex justify-center gap-2 px-4">
            {iconItems.map((icon, i) => (
              <Effects key={i} type="fadeup" delay={i * 70}>
                {icon}
              </Effects>
            ))}
          </div>
        )}
      </div>

      {body}
    </div>
  );
};

export default Card;

